import { ChevronLeft } from 'lucide-react'
import type { CSSProperties, ReactNode } from 'react'

export interface BackLinkProps {
  onClick: () => void
  children: ReactNode
  style?: CSSProperties
}

/** Chevron-left styled back navigation button. */
export function BackLink({ onClick, children, style }: BackLinkProps) {
  return (
    <button
      onClick={onClick}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: 'var(--ink-2)',
        fontSize: 14.5,
        fontWeight: 600,
        fontFamily: 'var(--font-body)',
        padding: '16px 0',
        ...style,
      }}
    >
      <ChevronLeft size={18} />
      {children}
    </button>
  )
}
